<div class="">
  <app-data-table [columns]="cols" [data]="userData" [title]="tableTitle" [url]="'/transaction/proposal-workflow/'"
    [isDeletable]="'/setup' | hasPermission: 'Delete'" [showAddButton]="'/setup' | hasPermission: 'Add'"
    [showActions]="canEditSetup" [isEditable]="'/setup' | hasPermission: 'Edit'" (onAdd)="addUser()"
    (onLazyLoadData)="getProposalWorkflow($event)" [totalRecords]="totalRecords"
    [isView]="'/setup' | hasPermission: 'View'" (viewEventRow)="viewSystem($event)" (editEventRow)="updateUser($event)"
    (deleteEventRow)="deleteUser($event)"></app-data-table>
</div>


<p-dialog header="Add Mapping" [(visible)]="showAddUserDialog" [modal]="true" [style]="{ width: '700px' }"
  [closable]="true" [maximizable]="true">
  <form [formGroup]="menuForm" (ngSubmit)="saveMenu()">
    <div class="row mt-4">
      <div class="p-field  col-md-6">
        <label>Proposal</label>
        <p-dropdown id="menuParent" [options]="proposaldropdownData" formControlName="proposal" optionLabel="name"
          optionValue="id" placeholder="Select Proposal" [filter]="true" filterBy="name" appendTo="body">
        </p-dropdown>
      </div>
      <div class="p-field  col-md-6">
        <label>Proposal Step</label>
        <p-dropdown id="menuParent" [options]="stepropdownData" formControlName="proposalStep" optionLabel="name"
          optionValue="id" placeholder="Select Proposal step" [filter]="true" filterBy="name"
          (onChange)="onStepChange($event)">
        </p-dropdown>
      </div>
    </div>
    <div class="row mt-4" *ngIf="!this.menuForm.get('approved')?.value">
      <div class="p-field  col-md-6">
        <label>Directorate</label>
        <p-dropdown [options]="unitList" formControlName="unit" optionValue="id" optionLabel="name"
          placeholder="Select a Directorate" class="w-100" (onChange)="onUnitChange($event)" [filter]="true"
          filterBy="name" appendTo="body">
        </p-dropdown>
      </div>
      <div class="p-field  col-md-6">
        <label>User</label>
        <p-dropdown [options]="userdropdownData" optionLabel="first_name" optionValue="id" placeholder="Select a User"
          formControlName="user" class="w-full md:w-56 select-label" [filter]="true" filterBy="name" appendTo="body"
          (onChange)="onUserChange($event)">
          <ng-template let-user pTemplate="item">
            <div class="list-group-item list-group-item-action">
              {{ user.hrcdf_designation }} {{ user.first_name }} {{ user.last_name }} - <small>{{ user.loginname
                }}</small>
            </div>
          </ng-template>
        </p-dropdown>
      </div>
    </div>
    <div class="row mt-4 mb-4" *ngIf="!this.menuForm.get('approved')?.value">
      <div class="p-field  col-md-6" *ngIf="!this.menuForm.get('approved')?.value">
        <label>Role</label>
        <p-dropdown id="menuParent" [options]="roledropdownData" formControlName="role" optionLabel="name"
          optionValue="id" placeholder="Select Role" [filter]="true" filterBy="name" appendTo="body"
          (onChange)="onRoleChange($event)">
        </p-dropdown>
      </div>
      <div class="p-field col-md-6">
        <label for="menuIcon">Sequence</label>
        <input id="menuIcon" type="text" pInputText formControlName="sequence" placeholder="Enter Sequence"
          [disabled]="true" />
      </div>
    </div>

    <div class="p-field-checkbox col-md-6 ad-user mt-4">
      <p-checkbox formControlName="approved" binary="true" inputId="ad_user" class="custom-checkbox"></p-checkbox>
      <label for="ad_user">Approve</label>
    </div>
    <div class=" footer-btn  mt-6">
      <button pButton label="Save" type="submit" [disabled]="menuForm.invalid" class="fetch-data-btn"></button>
    </div>
  </form>
</p-dialog>

<p-dialog [header]="viewMode ? 'View Mapping' : 'Edit Mapping'" [(visible)]="showEditUserDialog" [modal]="true"
  [style]="{ width: '700px' }" [closable]="true" [maximizable]="true">
  <form [formGroup]="menuForm" (ngSubmit)="saveUpdatedMenu()">
    <div class="row mt-4">
      <div class="p-field  col-md-6">
        <label>Proposal</label>
        <p-dropdown id="menuParent" [options]="proposaldropdownData" formControlName="proposal" optionLabel="name"
          optionValue="id" placeholder="Select Proposal" [filter]="true" filterBy="name" appendTo="body">
        </p-dropdown>
      </div>
      <div class="p-field  col-md-6">
        <label>Proposal Step</label>
        <p-dropdown id="menuParent" [options]="stepropdownData" formControlName="proposalStep" optionLabel="name"
          optionValue="id" placeholder="Select Proposal step" [filter]="true" filterBy="name"
          (onChange)="onStepChange($event)">
        </p-dropdown>
      </div>
    </div>
    <div class="row mt-4" *ngIf="!this.menuForm.get('approved')?.value">
      <div class="p-field  col-md-6">
        <label>Directorate</label>
        <p-dropdown [options]="unitList" formControlName="unit" optionValue="id" optionLabel="name"
          placeholder="Select a Directorate" class="w-100" (onChange)="onUnitChange($event)" [filter]="true"
          filterBy="name">
        </p-dropdown>
      </div>
      <div class="p-field  col-md-6">
        <label>User</label>
        <p-dropdown [options]="userdropdownData" optionLabel="first_name" optionValue="id" placeholder="Select a User"
          formControlName="user" class="w-full md:w-56 select-label" [filter]="true" filterBy="name" appendTo="body"
          (onChange)="onUserChange($event)">
        </p-dropdown>
      </div>
    </div>
    <div class="row mt-4 mb-4" *ngIf="!this.menuForm.get('approved')?.value">
      <div class="p-field  col-md-6" *ngIf="!this.menuForm.get('approved')?.value">
        <label>Role</label>
        <p-dropdown id="menuParent" [options]="roledropdownData" formControlName="role" optionLabel="name"
          optionValue="id" placeholder="Select Role" [filter]="true" filterBy="name" appendTo="body"
          (onChange)="onRoleChange($event)">
        </p-dropdown>
      </div>
      <div class="p-field col-md-6">
        <label for="menuIcon">Sequence</label>
        <input id="menuIcon" type="text" pInputText formControlName="sequence" placeholder="Enter Sequence"
          [disabled]="true" />
      </div>
    </div>

    <div class="p-field-checkbox col-md-6 ad-user mt-4">
      <p-checkbox formControlName="approved" binary="true" inputId="ad_user" class="custom-checkbox"></p-checkbox>
      <label for="ad_user">Approve</label>
    </div>
    <div class=" footer-btn  mt-6">
      <button pButton label="Save" type="submit" [disabled]="menuForm.invalid" *ngIf="!viewMode"
        class="fetch-data-btn"></button>
    </div>
  </form>
</p-dialog>

<p-dialog header="Delete Mapping" [modal]="true" [(visible)]="showDeleteDialog" [style]="{ width: '30rem' }"
  [maximizable]="true">
  <div class="delete-dialog mt-3">
    <i class="pi pi-trash text-danger custom-delete-icon"></i>
    <span>Are you sure , you want to delete mapping ?</span>
    <p-button label="Delete" icon="pi pi-trash" severity="danger" [outlined]="true" (click)="confirmDelete()"
      class="mt-2">
    </p-button>
  </div>
</p-dialog>